import { render, staticRenderFns } from "./assess-comment.vue?vue&type=template&id=6141a426&scoped=true"
import script from "./assess-comment.vue?vue&type=script&lang=js"
export * from "./assess-comment.vue?vue&type=script&lang=js"
import style0 from "./assess-comment.vue?vue&type=style&index=0&id=6141a426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6141a426",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImage: require('/builds/wj/fe/wenjuan-homesite/components/common/image.vue').default})
